import React from 'react';
import LoadingSpinner from './components/LoadingSpinner';
import Loading from './Loading';
import LoadingDataGrid from './LoadingDataGrid';
import LoadingWithOverlay from './LoadingWithOverlay';

export interface LoadingCommonProps {
  loading?: boolean;
  type?: 'light' | 'dark';
  style?: React.CSSProperties;
}

export default Loading;
export { LoadingWithOverlay, LoadingSpinner, LoadingDataGrid };
